module.exports = __webpack_public_path__ + "757e569f25d399a1c2071191d84bec20.svg";